module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/mv_img04-e5ef0999d2fb9e416e970bfea55a5d12.png";